import React, { type ReactElement } from 'react';
import { type MapStateToProps, connect } from 'react-redux';

import * as D from '../deps';

import BackstagePlayableRowItem from './BackstagePlayableRowItem';

const { formatTime, getArt, isUnavailable, isRadioOnly, getInDomain } = D;

export interface IBackstageTrackListItemStateProps {
  imgUrl?: string;
  secondText?: string | ReactElement;
  secondTextUrl?: string;
  trackName?: string | ReactElement;
  trackUrl?: string;
  trackDuration?: string;
  isClean?: boolean;
  isExplicit?: boolean;
  isUnavailable?: boolean;
  isRadioOnly?: boolean;
  inCollectionAlbumId?: string;
  isAlbumRadioOnly?: boolean;
  sourceCardAlbumId?: string;
  rowNumber?: number;
  isPlaceholder?: boolean;
  dominantColor?: string;
  isWidthHalf?: boolean;
}

export interface IBackstageTrackListItemOwnProps {
  playIndex?: number;
  pandoraId: string;
  playablePandoraId: string;
  isAlbumBSP?: boolean;
  showArtistName?: boolean;
  isCompilation?: boolean;
  showAlbumName?: boolean;
  isAlbumCollected?: boolean;
  hasBorderTopBottom?: boolean;
}

export type IBackstageTrackListItemProps = IBackstageTrackListItemStateProps &
  IBackstageTrackListItemOwnProps;

export const BackstageTrackListItem: React.FC<IBackstageTrackListItemProps> = props => {
  return (
    <BackstagePlayableRowItem
      pandoraId={props.pandoraId}
      playablePandoraId={props.playablePandoraId}
      playIndex={props.playIndex}
      isRowSmall={props.isAlbumBSP}
      pandoraType={D.PandoraTypes.SONG}
      imgUrl={props.imgUrl}
      itemName={props.trackName}
      itemUrl={props.trackUrl}
      secondText={props.secondText}
      secondTextUrl={props.secondTextUrl}
      trackDuration={props.trackDuration}
      isExplicit={props.isExplicit}
      isClean={props.isClean}
      isUnavailable={props.isUnavailable}
      isRadioOnly={props.isRadioOnly}
      rowNumber={props.rowNumber}
      hasBorderTopBottom={props.hasBorderTopBottom}
      isPlaceholder={props.isPlaceholder}
      dominantColor={props.dominantColor}
      isAlbumRadioOnly={props.isAlbumRadioOnly}
      inCollectionAlbumId={props.inCollectionAlbumId}
      sourceCardAlbumId={props.sourceCardAlbumId}
      isWidthHalf={props.isWidthHalf}
    />
  );
};

BackstageTrackListItem.defaultProps = {
  isAlbumBSP: false,
};

export const mapStateToProps: MapStateToProps<
  IBackstageTrackListItemStateProps,
  IBackstageTrackListItemOwnProps,
  $TSFixMe
> = (state, ownProps) => {
  const track = getInDomain('catalog.utils.getAnnotations')(state, ownProps.pandoraId);
  const album = getInDomain('catalog.utils.getAnnotations')(state, track.get('albumId'));
  const props = {};

  if (!track || track.isEmpty()) {
    // @ts-expect-error TS(2339) FIXME: Property 'isPlaceholder' does not exist on type '{... Remove this comment to see the full error message
    props.isPlaceholder = true;
    return props;
  }
  // @ts-expect-error TS(2339) FIXME: Property 'playablePandoraId' does not exist on typ... Remove this comment to see the full error message
  props.playablePandoraId = ownProps.playablePandoraId;
  // @ts-expect-error TS(2339) FIXME: Property 'isPlaceholder' does not exist on type '{... Remove this comment to see the full error message
  props.isPlaceholder = false;
  // @ts-expect-error TS(2339) FIXME: Property 'imgUrl' does not exist on type '{}'.
  props.imgUrl = getArt(track, 90, state);
  // @ts-expect-error TS(2339) FIXME: Property 'trackName' does not exist on type '{}'.
  props.trackName = track.get('name');
  // @ts-expect-error TS(2339) FIXME: Property 'trackUrl' does not exist on type '{}'.
  props.trackUrl = track.get('shareableUrlPath');
  // @ts-expect-error TS(2339) FIXME: Property 'trackDuration' does not exist on type '{... Remove this comment to see the full error message
  props.trackDuration = formatTime(track.get('duration'));
  // @ts-expect-error TS(2339) FIXME: Property 'secondText' does not exist on type '{}'.
  props.secondText = album.get('name');
  // @ts-expect-error TS(2339) FIXME: Property 'secondTextUrl' does not exist on type '{... Remove this comment to see the full error message
  props.secondTextUrl = album.get('shareableUrlPath');
  if (ownProps.isAlbumBSP || ownProps.showArtistName) {
    const artist = getInDomain('catalog.utils.getAnnotations')(state, track.get('artistId'));
    // @ts-expect-error TS(2339) FIXME: Property 'secondText' does not exist on type '{}'.
    props.secondText =
      ownProps.isCompilation || ownProps.showArtistName ? track.get('artistName') : null;
    // @ts-expect-error TS(2339) FIXME: Property 'secondTextUrl' does not exist on type '{... Remove this comment to see the full error message
    props.secondTextUrl = artist.get('shareableUrlPath');
  } else if (ownProps.showAlbumName) {
    // @ts-expect-error TS(2339) FIXME: Property 'secondText' does not exist on type '{}'.
    props.secondText = album.get('name') || track.get('albumName');
    // @ts-expect-error TS(2339) FIXME: Property 'secondTextUrl' does not exist on type '{... Remove this comment to see the full error message
    props.secondTextUrl = album.get('shareableUrlPath') || track.get('albumShareableUrlPath');
  }

  if (ownProps.isAlbumBSP) {
    // @ts-expect-error TS(2339) FIXME: Property 'rowNumber' does not exist on type '{}'.
    props.rowNumber = track.get('trackNumber');
  }

  const isShortReleaseType =
    getInDomain('catalog.utils.isSingleRelease')(album) ||
    getInDomain('catalog.utils.isEpRelease')(album);
  // @ts-expect-error TS(2339) FIXME: Property 'sourceCardAlbumId' does not exist on typ... Remove this comment to see the full error message
  props.sourceCardAlbumId =
    ownProps.isAlbumCollected || isShortReleaseType ? track.get('albumId') : null;
  // @ts-expect-error TS(2339) FIXME: Property 'isClean' does not exist on type '{}'.
  props.isClean = getInDomain('catalog.utils.isClean')(track);
  // @ts-expect-error TS(2339) FIXME: Property 'isExplicit' does not exist on type '{}'.
  props.isExplicit = getInDomain('catalog.utils.isExplicit')(track);
  // @ts-expect-error TS(2339) FIXME: Property 'inCollectionAlbumId' does not exist on t... Remove this comment to see the full error message
  props.inCollectionAlbumId = !ownProps.isAlbumBSP ? track.get('albumId') : null;
  // @ts-expect-error TS(2339) FIXME: Property 'isUnavailable' does not exist on type '{... Remove this comment to see the full error message
  props.isUnavailable = isUnavailable(track);
  // @ts-expect-error TS(2339) FIXME: Property 'isRadioOnly' does not exist on type '{}'... Remove this comment to see the full error message
  props.isRadioOnly = isRadioOnly(track);
  // @ts-expect-error TS(2339) FIXME: Property 'dominantColor' does not exist on type '{... Remove this comment to see the full error message
  props.dominantColor = D.Utils.Art.getDominantColor(track);

  // @ts-expect-error TS(2339) FIXME: Property 'showPremiumAccess' does not exist on typ... Remove this comment to see the full error message
  props.showPremiumAccess = D.Utils.Listener.showPremiumAccess(state);
  return props;
};

export default connect(mapStateToProps)(BackstageTrackListItem);
